import { memo } from 'react';

import UnlinkIconSVG from '@/assets/unlink-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IUnlinkIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={UnlinkIconSVG} {...props} />;

export const UnlinkIcon = memo(IUnlinkIcon) as typeof IUnlinkIcon;
